module.exports = __webpack_public_path__ + "img/post.7d5f057e.png";